<script>
  import { layoutMethods, billsPaymentMethods, exportMethods } from "@/state/helpers";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * PRP Category List component
   */
  export default {
    page: {
      title: "Bills Payment Category"
    },
    components: {
    },
    computed: {
    },
    data() {
      return {
        title: "Bills Payment Category",
        searchValue: {
            search: null,
            searchField: null,
            page: 1,
            rows: 10,
            sort: 'id',
            orderDesc: true,
            status: null,
        },
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Category Code', value: "code" },
          { text: 'Category Description', value: "description" },
          { text: 'Created By', value: "created_by" }
        ],
        fields: [
          { key: "code", label: "Categories Code", sortable: true},
          { key: "description", label: "Categories Description", sortable: true},
          { key: "icon", label: "Icons", sortable: false},
          { key: "status", label: "Status", sortable: true},
          { key: "sequence", label: "Categories Sequence", sortable: true},
          { key: "created_by", label: "Created By", sortable: true},        
        ], 
        statusList: [
          { text: 'All', value: null },
          { text: 'Active', value: 1 },
          { text: 'Inactive', value: 0 },
        ],
        totalCategory: 0,
        listCategory:[],
        sortBy: "value",
        sortDesc: false,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        billsPaymentCategory: {
          access: {
            create: true,
            read: true,
            update: true,
            delete: true
          }
        }
      };
    },
    methods: {
      ...layoutMethods,
      ...billsPaymentMethods,
      ...exportMethods,
      exportLogs(){
        this.isOpen = false;
        console.log(this.searchValue);
        var params = {
          ...this.searchValue,
          module: 'bills_payment_category',
          email: JSON.parse(localStorage.getItem('userData')).email
        }
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      addBillsPaymentCategory(){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Bills Payment Category Form", params: { categoryId: 0}
          }
        );
      },
      refresh(){
       this.onSearch();
      },
      async onSearch(state=''){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        console.log(":: search value ::",JSON.stringify(this.searchValue));
        await this.actionBillsPaymentCategory({
            action: "list",
            body: this.searchValue
        })
        .then((res) => {
          this.totalCategory = res["message"]["pageInfo"]["total"] 
          this.listCategory = res["message"]["rows"]
          console.log(res);
        }).catch((e)=>{
          console.log("error while getting list",e);
        });
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        console.log("asdadasda ctx:", ctx);
        this.searchValue.orderDesc = ctx.sortDesc;
        this.onSearch('reset');
      },
    },
    async mounted(){
      this.changeTitle({title: 'Bills Payment Category'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Bills Payment Category', to: { name: 'Bills Payment Category'} }
        ]
      });
      await this.onSearch();

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Category')
        .then((access) => this.billsPaymentCategory.access = access);
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{ totalCategory }} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="col-md-8 col-sm-8">
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <a v-if="billsPaymentCategory.access.create" class="btn btn-primary me-2" @click="addBillsPaymentCategory">
                                  <i class="uil uil-plus me-1"></i> Add Category
                                </a>
                                 <b-button variant="primary" type="button" @click="exportLogs" class="px-2 me-2 btn btn-primary h-fit">
                                    <i class='uil uil-export me-1'></i> Export
                                  </b-button>
                                <a class="btn btn-secondary"
                                  @click="refresh"
                                    ><feather
                                    type="refresh-ccw"
                                    size="16"
                                    class="icon nav-icon"
                                    ></feather
                                    >&nbsp;&nbsp; Refresh</a
                                >
                                
                            </div>
                            
                        </div>
                        
                        
                        <!-- end col-8 --> 
                        <div class="row">
                          <div class="w-auto mb-2">
                            <div class="d-flex mt-3 mb-3">
                              <div class="me-3">
                                <form class="d-flex" @submit.prevent="onSearch('reset')">
                                  <b-form-group id="input-group-3" label-for="input-3">
                                    <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.searchField" :options="searchOptions"></b-form-select>
                                  </b-form-group>
                                  <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                                    <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                                    <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                                  </b-form-group>
                                </form>
                              </div>
                              <div class="me-3">
                                <b-form-group label="">
                                  <b-button variant="primary" type="button" @click="onSearch('reset')" class="px-2 me-2">
                                    <i class='bx bx-search bx-fw'></i>
                                    Search
                                  </b-button>
                                </b-form-group>
                              </div>
                              <div class="col-md-2 ta-right">
                                <b-form-group label-for="reward-status" description="Filter by status">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="reward-status"
                                    v-model="searchValue.status"
                                    :options="statusList"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end search div--> 


                        <div class="table-responsive">
                          <div class="table align-middle table-nowrap">
                            <b-table
                              :items="listCategory"
                              :fields="fields"
                              responsive="sm"
                              :current-page="searchValue.page"
                              :sort-by.sync="sortBy"
                              :sort-desc.sync="sortDesc"
                              @sort-changed="tableSorting"
                              class="table-check"
                            >
                              <template #cell(code)="data">
                                {{ data.item.categoryCode }}
                              </template>
                              <template #cell(description)="data">
                                <span class="text-body m-0 text-capitalize">
                                  <router-link :to="{ name: 'Bills Payment Category Form', params: { categoryId : data.item.categoryId }}" 
                                  class="customer-name">
                                    {{ data.item.categoryDescription}}
                                  </router-link>
                                </span>
                              </template>
                              <template #cell(icon)="data">
                                <img :src="data.item.categoryIconSrc" alt="" class="rounded avatar" @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')">
                              </template>
                              <template #cell(status)="data">
                                  <span class="text-success" v-if="data.item.categoryStatus == 1">
                                    Active
                                  </span>
                                  <span class="text-danger" v-else>
                                    Inactive
                                  </span>
                              </template>
                              <template #cell(sequence)="data">
                                {{ data.item.categorySequence }}
                              </template>
                              <template #cell(created_by)="data">
                                <!-- System Generated if "-" -->
                                {{ data.item.createdBy }}
                              </template>
                              <!-- <template #cell(action)="data">
                                  <b-button variant="danger" class="p-1" @click="deleteCategory(data.item)"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                              </template> -->
                            </b-table>
                          </div>
                        </div>
                        <div class="row g-0 text-center" v-if="totalCategory == 0">
                          <span>No data to display.</span>
                        </div>
                        <div class="row" v-if="totalCategory > 0">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="searchValue.rows"
                                    :options="pageOptions"
                                    @change="onSearch('reset')"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <b-pagination
                                v-if="totalCategory != 0 && totalCategory > searchValue.rows"
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="totalCategory"
                                @input="onSearch()"
                                :per-page="searchValue.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- end row -->
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>